import React, { type DetailedHTMLProps, type HTMLAttributes, forwardRef } from "react";
import { twJoin } from "tailwind-merge";

interface GrabberProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  disabled?: boolean;
}

export const Grabber = forwardRef<HTMLDivElement, GrabberProps>(function DefaultGrabber(props, ref) {
  const { disabled = false, className, ...restProps } = props;

  return (
    <div ref={ref} {...restProps} className={twJoin("sup-slider-grabber", className, "w-0 h-1px")}>
      <span
        tabIndex={0}
        className={twJoin(
          "absolute p-0.5 border-0.5 rounded-full outline-0 transition-all -translate-x-1/2 -translate-y-1/2 duration-200 bg-primary-50 border-primary-500",
          !disabled
            ? "hover:border-neutral-700 hover:bg-neutral-100 focus:border focus:border-neutral-400 focus:bg-neutral-200 active:border active:bg-neutral-300 active:border-neutral-400"
            : ""
        )}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
          <rect x="3.64014" y="3.16003" width="0.48" height="5.76" fill="currentColor" />
          <rect x="6.04004" y="3.16003" width="0.48" height="5.76" fill="currentColor" />
          <rect x="8.44019" y="3.16003" width="0.48" height="5.76" fill="currentColor" />
        </svg>
      </span>
    </div>
  );
});
